'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DeviceAssignmentAlertsPage } from '../../-components/DeviceAssignmentAlertsPage';
import { DEVICE_ASSIGNMENT_ALERT_CATEGORY } from '../../-constants';
import { DeviceAssignmentAlertsSearchSchema } from '../../-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts/unknown-assignment/')({
  validateSearch: zodValidator(DeviceAssignmentAlertsSearchSchema),
  component: UnknownAssignmentAlertsPage
});
function UnknownAssignmentAlertsPage() {
  return <DeviceAssignmentAlertsPage category={DEVICE_ASSIGNMENT_ALERT_CATEGORY.UNKNOWN_ASSIGNMENT} categoryKey="unknownAssignment" />;
}